import { Err, Ok } from "@siteimprove/alfa-result";
import { Style } from "@siteimprove/alfa-style";
import { expectation } from "../act/expectation.js";
import { TextSpacing } from "../diagnostic/text-spacing.js";
/**
 * @internal
 */
export function isWideEnough(target, device, property, threshold) {
    const style = Style.from(target, device);
    const fontSize = style.computed("font-size").value;
    const value = style.computed(property).value;
    // The source is guaranteed to exist by the hasSpecifiedStyle
    // filter in Applicability.
    const declaration = style.computed(property).source.getUnsafe();
    let ratio;
    let used;
    switch (value.type) {
        case "length":
            used = value;
            ratio = value.value / fontSize.value;
            break;
        case "number":
            used = fontSize.scale(value.value);
            ratio = value.value;
            break;
        case "keyword":
            // Used value for font-size of `normal` is 1.2 times font-size.
            used = fontSize.scale(1.2);
            ratio = 1.2;
    }
    return {
        1: expectation(ratio >= threshold, () => Outcomes.IsWideEnough(property, used, fontSize, ratio, threshold, declaration, 
        // The owner is guaranteed to exist by the hasSpecifiedStyle
        // filter in Applicability.
        declaration.owner.getUnsafe()), () => Outcomes.IsNotWideEnough(property, used, fontSize, ratio, threshold, declaration, 
        // The owner is guaranteed to exist by the hasSpecifiedStyle
        // filter in Applicability.
        declaration.owner.getUnsafe())),
    };
}
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.IsWideEnough = (prop, value, fontSize, ratio, threshold, declaration, owner) => Ok.of(TextSpacing.of(`${prop} is at least ${threshold} times the font-size`, prop, value, fontSize, ratio, threshold, declaration, owner));
    Outcomes.IsNotWideEnough = (prop, value, fontSize, ratio, threshold, declaration, owner) => Err.of(TextSpacing.of(`${prop} is less than ${threshold} times the font-size`, prop, value, fontSize, ratio, threshold, declaration, owner));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=is-wide-enough.js.map